import React from 'react';
import { Card, renderRow } from 'components';
import { formatPhoneNumber } from '_helpers';
import cn from 'classnames';
import moment from 'moment';

const PersonalDataTab = ({
    personalData,
    cardTitle,
    cardCategory,
    withoutPadding,
    withoutEmail,
    withoutPhone,
    withoutPaddingRows,
    withoutRegion,
    cardClassName,
    rowClassName,
    withExpert,
}: IProps) => (
        <Card
          title={cardTitle === null ? undefined : (cardTitle || 'Личные данные')}
          category={cardCategory === null ? undefined : (cardCategory || 'Общая информация об эксперте')}
          withoutPadding={withoutPadding}
          cardClassName={cardClassName}
          withoutBorder
        >
            {personalData ? (
                <>
                    {renderRow('Фамилия', personalData.lastName, rowClassName)}
                    {renderRow('Имя', personalData.firstName, rowClassName)}
                    {renderRow('Отчество', personalData.middleName, rowClassName)}

                    {renderRow('Дата рождения', personalData.birthDate.format('DD.MM.YYYY'), cn(rowClassName, !withoutPaddingRows && 'mt-5'))}
                    {withExpert ? renderRow('Тип', personalData.isExpert ? 'Эксперт' : 'Соискатель') : null}
                    {!withoutRegion ? renderRow('Регион', personalData.region) : null}

                    {!withoutPhone ? renderRow('Телефон', formatPhoneNumber(personalData.phone) || personalData.phone, cn(rowClassName, !withoutPaddingRows && 'mt-5')) : null}
                    {!withoutEmail ? renderRow('Почта', personalData.email) : null}
                </>
            ) : null}
        </Card>
    );

export default PersonalDataTab;

interface IProps {
    personalData: IPersonalData | null;
    cardTitle?: string | null;
    cardCategory?: string | null;
    withoutPadding?: boolean;
    withoutPhone?: boolean;
    withoutEmail?: boolean;
    withoutPaddingRows?: boolean;
    withoutRegion?: boolean;
    withExpert?: boolean;
    cardClassName?: string;
    rowClassName?: string;
}

interface IPersonalData {
    lastName: string;
    firstName: string;
    birthDate: moment.Moment;
    phone: string;
    email: string;
    middleName?: string;
    region?: string;
    isExpert?: boolean;
}
